import * as XLSX from 'xlsx';
import { ExportConfig, getCellValue, generateFileName, downloadBlob } from './types';

export const exportXlsx = (config: ExportConfig): void => {
  const { title, columns, data, fileName } = config;

  const headers = columns.map(c => c.label);
  const rows = data.map(row => columns.map(col => getCellValue(row, col)));

  const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);

  ws['!cols'] = columns.map((col, i) => {
    const maxLen = Math.max(
      col.label.length,
      ...rows.map(r => (r[i] || '').length)
    );
    return { wch: Math.min(Math.max(maxLen + 2, 10), 40) };
  });

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, title.substring(0, 31));

  const wbOut = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([wbOut], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  downloadBlob(blob, (fileName || generateFileName(title)) + '.xlsx');
};
